export enum MessageText {
  SUCSSES = 'Задание отправлено на проверку.',
  ERROR = 'Произошел сбой в работе оборудования, задание не отправлено. Попробуйте еще раз позже.',
}



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/compopnents/block/components/resultform/types.ts